import dayjs, { Dayjs } from "dayjs";
import { FilterValue } from "../../Filters/FilterValue";
import { SortType } from "../../SortType";

export interface PartnerAnalyticsFilters {
  page: number;
  limit: number;
  search: string | null;
  partner_id: FilterValue[];
  labels: FilterValue[];
  shipment_status: FilterValue[] | null;
  shipment_type: FilterValue[] | null;
  start_date: Dayjs;
  end_date: Dayjs;
  sortBy: string;
  sortType: SortType;
}

export interface PartnerAnalyticsSelectedFilters {
  page: number;
  limit: number;
  search: string | null;
  partner_id: FilterValue[];
  labels: FilterValue[];
  shipment_status: FilterValue[] | null;
  shipment_type: FilterValue[] | null;
  start_date: string;
  end_date: string;
  sortBy: string;
  sortType: SortType;
}

export interface PartnerAnalyticsAPIFilters {
  partner_id: FilterValue[] | null;
  start_date: string;
  end_date: string;
}

export function parseQueryParamsForParterAnalyticsFilters(
  params: PartnerAnalyticsFilters | null,
  query_params: URLSearchParams
): PartnerAnalyticsFilters {
  const currentDate = dayjs().startOf("day");
  const previousMonthDate = currentDate.startOf("month");

  return {
    page: params?.page ?? 1,
    limit: params?.limit ?? 30,
    search: params?.search ?? "",
    partner_id: params?.partner_id ?? [],
    labels: params?.labels ?? [],
    shipment_status: params?.shipment_status ?? [],
    shipment_type: params?.shipment_type ?? [],
    start_date: query_params.get("start_date")
      ? dayjs(query_params.get("start_date"), "YYYY-MM-DD")
      : previousMonthDate,
    end_date: query_params.get("end_date")
      ? dayjs(query_params.get("end_date"), "YYYY-MM-DD")
      : currentDate,
    sortBy: params?.sortBy || "created_date",
    sortType: params?.sortType ?? SortType.DESC,
  };
}
